import { Icon } from "./Icon";

const iosUrl = import.meta.env.VITE_IOS_URL || "";
const androidUrl = import.meta.env.VITE_ANDROID_URL || "";
const appUrl = import.meta.env.VITE_APP_SITE_URL || "https://eternallyblessed-site.pages.dev/#app";

export function AppInvitation() {
  return (
    <section className="app-invitation" aria-labelledby="app-invitation-title">
      <div className="app-invitation__copy">
        <div className="section-kicker">THE ETERNALLY BLESSED APP</div>
        <h2 id="app-invitation-title">A verse for your day.<br /><em>A little room for God.</em></h2>
        <p>Start with one verse. Understand its context, carry it into your day, and explore a little further whenever you like.</p>
        <div className="app-invitation__links">
          {iosUrl && <a className="app-download" href={iosUrl}>Get the iPhone app <Icon name="arrow" /></a>}
          {androidUrl && <a className="app-download" href={androidUrl}>Get the Android app <Icon name="arrow" /></a>}
          {!iosUrl && !androidUrl && <a className="app-download" href={appUrl}>Meet your daily companion <Icon name="arrow" /></a>}
        </div>
        {!iosUrl && !androidUrl && <small>Coming to iPhone and Android.</small>}
      </div>
      <div className="app-invitation__art" aria-hidden="true">
        <img src="/art/app-story.webp" alt="" loading="lazy" width="1536" height="1024" />
        <div className="verse-preview">
          <img src="/brand/mark-reversed.svg" alt="" width="32" height="32" />
          <span>YOUR DAILY VERSE</span>
          <p>“I am come that they might have life, and that they might have it more abundantly.”</p>
          <small>JOHN 10:10 · KJV</small>
        </div>
      </div>
    </section>
  );
}
